import { render, staticRenderFns } from "./EditMappingDomain.vue?vue&type=template&id=bc3bda42&scoped=true"
import script from "./EditMappingDomain.vue?vue&type=script&lang=js"
export * from "./EditMappingDomain.vue?vue&type=script&lang=js"
import style0 from "./EditMappingDomain.vue?vue&type=style&index=0&id=bc3bda42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3bda42",
  null
  
)

export default component.exports